"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var FinalPriceDefaultEnum_1 = require("../model/FinalPriceDefaultEnum");

var GlobalSettings_1 = require("../model/GlobalSettings");

var GlobalSettingsConverter_1 = require("./GlobalSettingsConverter");
/**
 * Implementation of {@link GlobalSettings}
 * @author RV
 */


var GlobalSettingsConverterImpl =
/*#__PURE__*/
function (_GlobalSettingsConver) {
  _inherits(GlobalSettingsConverterImpl, _GlobalSettingsConver);

  function GlobalSettingsConverterImpl() {
    _classCallCheck(this, GlobalSettingsConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(GlobalSettingsConverterImpl).apply(this, arguments));
  }

  _createClass(GlobalSettingsConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new GlobalSettings_1.GlobalSettings(conversions.documentToClassId(source), GlobalSettings_1.GlobalSettings.schema.familySettings.valueOfField(source), GlobalSettings_1.GlobalSettings.schema.cleaningSettings.valueOfField(source), conversions.asEnum(source.finalPriceDefault, FinalPriceDefaultEnum_1.FinalPriceDefaultEnum), source.impactHistoryLength, conversions.asObject(source, 'sensitivityDefaultId', function (value) {
        return conversions.toClassReferenceId(value);
      }), source.missingCompetitorPrice, source.priceStickerLimit);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        familySettings: conversions.asObjectOpt(source, 'familySettings', this.serializeFamilySettings(conversions)),
        cleaningSettings: conversions.asObjectOpt(source, 'cleaningSettings', this.serializeCleaningSettings(conversions)),
        finalPriceDefault: source.finalPriceDefault,
        impactHistoryLength: source.impactHistoryLength,
        sensitivityDefaultId: conversions.toDocumentReferenceId(source.sensitivityDefaultId),
        missingCompetitorPrice: source.missingCompetitorPrice,
        priceStickerLimit: source.priceStickerLimit
      });
      return result;
    }
  }, {
    key: "serializeFamilySettings",
    value: function serializeFamilySettings(conversions) {
      return function (object) {
        return {
          leaderMaxHistoryLength: object.leaderMaxHistoryLength,
          leaderFrequencyRecalculation: object.leaderFrequencyRecalculation
        };
      };
    }
  }, {
    key: "serializeOutlierPriceDetectionSystem",
    value: function serializeOutlierPriceDetectionSystem(conversions) {
      return function (object) {
        return {
          outlierHistoryLength: object.outlierHistoryLength,
          outlierLimit: object.outlierLimit
        };
      };
    }
  }, {
    key: "serializePromoPriceDetectionSettings",
    value: function serializePromoPriceDetectionSettings(conversions) {
      return function (object) {
        return {
          minPriceDecrease: object.minPriceDecrease,
          minPriceIncrease: object.minPriceIncrease,
          minPriceLength: object.minPriceLength,
          maxPriceLength: object.maxPriceLength,
          promoLimit: object.promoLimit
        };
      };
    }
  }, {
    key: "serializeCleaningSettings",
    value: function serializeCleaningSettings(conversions) {
      var _this = this;

      return function (object) {
        return {
          outlierPriceDetectionSettings: conversions.asObject(object, 'outlierPriceDetectionSettings', _this.serializeOutlierPriceDetectionSystem(conversions)),
          promoPriceDetectionSettings: conversions.asObject(object, 'promoPriceDetectionSettings', _this.serializePromoPriceDetectionSettings(conversions)),
          referencePriceChangeIndex: object.referencePriceChangeIndex,
          competitorReferencePriceChangeIndex: object.competitorReferencePriceChangeIndex,
          internalVsCompetitorReferencePriceChangeIndex: object.internalVsCompetitorReferencePriceChangeIndex,
          extremePriceChangeIndex: object.extremePriceChangeIndex,
          agencyResearchWeight: object.agencyResearchWeight,
          webscrapingWeight: object.webscrapingWeight
        };
      };
    }
  }]);

  return GlobalSettingsConverterImpl;
}(GlobalSettingsConverter_1.GlobalSettingsConverter);

exports.GlobalSettingsConverterImpl = GlobalSettingsConverterImpl;